import styled from 'styled-components';

export const EventCard = styled.div`
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  background-color: #fff;
  transition: all 0.2s ease-in-out;
  
  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const EventStatusBadge = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${props => (props.published ? '#28a745' : '#ffc107')};
  margin-right: 6px;
`;

export const EventTitle = styled.h5`
  font-weight: 600;
  margin-bottom: 10px;
`;

export const EventDescription = styled.p`
  color: #6c757d;
  font-size: 14px;
  margin-bottom: 15px;
`;

export const EventDetail = styled.p`
  display: flex;
  align-items: center;
  margin: 0;
  margin-bottom: 8px;
  font-size: 14px;
  
  svg {
    margin-right: 8px;
    color: #6c757d;
  }
`;

export const StatusLabel = styled.span`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${props => {
    if (props.status === 'registered') return '#28a745';
    if (props.status === 'waitlisted') return '#ffc107';
    return '#6c757d';
  }};
  color: white;
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  color: #007bff;
  font-size: 14px;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const TemplateVariableContainer = styled.div`
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
`;

export const VariableItem = styled.div`
  display: flex;
  margin-bottom: 8px;
  
  .variable {
    color: #fd7e14;
    margin-right: 15px;
    font-family: monospace;
  }
  
  .description {
    color: #6c757d;
    font-size: 14px;
  }
`;

export const StyledEventHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e6e6e6;
`;

export const StyledStats = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 30px;
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
`;

export const StyledStatItem = styled.div`
  flex: 1;
  min-width: 150px;
  text-align: center;
  
  .stat-value {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 5px;
    color: #007bff;
  }
  
  .stat-label {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6c757d;
    font-size: 14px;
    
    svg {
      margin-right: 5px;
    }
  }
`;
